module.exports = __webpack_public_path__ + "img/location_on-white-24dp.b1c1cdaa.svg";